import React from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { LANDING_COLORS, landingBodySx, landingEyebrowSx, landingTitleSx } from './landingTokens';

const Eyebrow = ({ index, overline }) => {
  if (!index && !overline) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      {index && (
        <Typography component="span" sx={{ ...landingEyebrowSx, color: LANDING_COLORS.terracotta }}>
          {index}
        </Typography>
      )}
      <Box sx={{ width: 24, height: '1px', background: LANDING_COLORS.terracotta, opacity: 0.6 }} />
      {overline ? (
        <Typography component="span" sx={landingEyebrowSx}>
          {overline}
        </Typography>
      ) : null}
    </Stack>
  );
};

const SectionMasthead = ({ index, overline, title, subtitle, layout = 'split' }) => {
  const heading = (
    <Typography variant="h2" component="h2" sx={landingTitleSx}>
      {title}
    </Typography>
  );

  const description = subtitle ? (
    <Typography component="p" sx={landingBodySx}>
      {subtitle}
    </Typography>
  ) : null;

  if (layout === 'stacked') {
    return (
      <Stack spacing={2} sx={{ mb: { xs: 4, md: 5 } }}>
        <Eyebrow index={index} overline={overline} />
        {heading}
        {description}
      </Stack>
    );
  }

  return (
    <Box sx={{ mb: { xs: 5, md: 7 } }}>
      <Eyebrow index={index} overline={overline} />
      <Grid container spacing={{ xs: 2, md: 6 }} alignItems="flex-end" sx={{ mt: index || overline ? 2 : 0 }}>
        <Grid size={{ xs: 12, md: 7 }}>{heading}</Grid>
        <Grid size={{ xs: 12, md: 5 }}>{description}</Grid>
      </Grid>
    </Box>
  );
};

export default SectionMasthead;
